import Platform from '../base';
import navigationKeys from './config/keys/navigation';
import remoteKeys from './config/keys/remote-keys';
import './libs/webOS';
import storage from '../../helpers/storage';

const deviceYear = {
  '1.0': '2014',
  '2.0': '2015',
  '3.0': '2016',
  3.5: '2017',
  '4.0': '2018',
  4.5: '2019',
  '5.0': '2020',
  '6.0': '2021',
  '7.0': '2022',
  '8.0': '2023',
  '9.0': '2024',
  '10.0': '2025',
};

class Webos extends Platform {
  navigationKeys = navigationKeys;
  remoteKeys = remoteKeys;
  deviceInfo = {};

  initialize(opt) {
    super.initialize(opt);

    /* (function() {
      var s = document.createElement('script');
      s.src = 'https://remotejs.com/agent/agent.js';
      s.setAttribute('data-consolejs-channel', '707b7bc1-e4a3-dc8e-921a-87737fdcf28b');
      document.head.appendChild(s);
    })();*/

    /*

    const debugDiv = document.createElement('div');
    debugDiv.id = 'debug';
    debugDiv.setAttribute(
      'style',
      'bottom:0; display: block; position: absolute; z-index: 99999; width: 1280px; min-height: 660px;\n' +
        'background-color: darkblue; padding: 10px 50px; font-size: 32px; color: white; opacity: 0.5; vertical-align: bottom',
    );

    document.body.appendChild(debugDiv);

    console.log = function() {
      var debug = document.getElementById('debug');
      Array.prototype.forEach.call(arguments, function(message) {
        if (typeof message === 'object') message = JSON.stringify(message);
        var newMsg = document.createElement('div');
        newMsg.innerHTML = message;
        debug.appendChild(newMsg);
        debug.scrollTop += 50;
      });
    };*/

    return Promise.all([this.setSystemInfo(), this.getConnectionTypeFromTV()]);
  }

  _getDeviceId() {
    let sn = window.webOS.device.serialNumber;
    if (sn === 'Unknown' || !sn) {
      return undefined;
    }
    return sn;
  }

  setSystemInfo() {
    return new Promise((resolve, reject) => {
      window.webOS.deviceInfo((device) => {
        if (!device) return;
        this.deviceInfo.name = device.modelName;
        this.deviceInfo.firmware = device.version;
        this.deviceInfo.supportsUHD = device.uhd;
        this.deviceInfo.supportsUHD8K = device.uhd8K;
        this.deviceInfo.supportsHDR = device.hdr10;
        this.deviceInfo.sdkVersion = device.sdkVersion;
        this.deviceInfo.extraData = device;

        const webOSVersion = parseInt(device.sdkVersion?.charAt(0), 10);
        if (webOSVersion < 3) {
          this.deviceInfo.uuid = this.getDUID();
          resolve();
        } else {
          window.webOS.service.request('luna://com.webos.service.sm', {
            method: 'deviceid/getIDs',
            parameters: {
              idType: ['LGUDID'],
            },
            onSuccess: (response) => {
              const LGUDID = response.idList[0].idValue;
              this.deviceInfo.uuid = LGUDID ? LGUDID : this.getDUID();
              resolve();
            },
            onFailure: () => {
              resolve();
            },
          });
        }
      });
    });
  }

  isMouseControlSupported() {
    return true;
  }

  exit() {
    window.close();
  }

  supportsUHD() {
    return this.deviceInfo.supportsUHD || false;
  }

  supportsUHD8K() {
    return this.deviceInfo.supportsUHD8K || false;
  }

  supportsHDR() {
    return this.deviceInfo.supportsHDR || false;
  }

  getPlatformVersion() {
    return this.deviceInfo.sdkVersion || super.getPlatformVersion();
  }

  getFirmwareVersion() {
    return this.deviceInfo.firmware || super.getFirmwareVersion();
  }

  getMainSDKVersion() {
    const sdk = parseFloat(this.getPlatformVersion() || 0);
    const sdkFloor = Math.floor(sdk);
    if (sdk >= 3 && sdk - sdkFloor >= 0.5) {
      return `${sdkFloor}.5`;
    }
    return `${sdkFloor}.0`;
  }

  getModelYear() {
    const year = deviceYear[this.getMainSDKVersion()] || super.getModelYear();
    return parseInt(year, 10);
  }

  getModelDiagonal() {
    const tvModel = this.getModelName();
    let diagonal = tvModel.slice(0, 2);

    if (tvModel.toLowerCase().indexOf('oled') !== -1) {
      diagonal = tvModel.slice(4, 6);
    }

    return parseInt(diagonal, 10);
  }

  getModelName() {
    return this.deviceInfo.name || super.getModelName();
  }

  getUID() {
    return this.deviceInfo.uuid || super.getUID();
  }

  getDeviceType() {
    return this.getModelYear() <= 2017 ? 'OLD_TV' : 'SMART_TV';
  }

  getDeviceRegistrationType() {
    return 'LG WebOs';
  }

  getDUID() {
    let duid = storage.get('duid');

    if (!duid) {
      duid = (Date.now().toString(36) + Math.random().toString(36).substr(2, 9)).toUpperCase();
      storage.set('duid', duid);
    }

    return duid;
  }

  getBrand() {
    return 'LG';
  }

  getName() {
    return 'WebOS';
  }

  getConnectionType() {
    return this.deviceInfo.connectionType || super.getConnectionType();
  }

  getConnectionTypeFromTV() {
    return new Promise((resolve) => {
      this.deviceInfo.connectionType = 'Unknown';
      const self = this;

      window.webOS.service.request('luna://com.palm.connectionmanager', {
        method: 'getStatus',
        onSuccess: function (inResponse) {
          const isSucceeded = inResponse.returnValue;

          if (isSucceeded) {
            if (inResponse.wired.state === 'connected') {
              self.deviceInfo.connectionType = 'Ethernet';
            }
            if (inResponse.wifi.state === 'connected') {
              self.deviceInfo.connectionType = 'Wi-Fi';
            }
            if (inResponse.wifiDirect.state === 'connected') {
              self.deviceInfo.connectionType = 'Wi-Fi Direct';
            }
          }
          resolve();
        },
        onFailure: function (inError) {
          console.log('Failed to get network state');
          console.log(`[${inError.errorCode}]: ${inError.errorText}`);
          resolve();
        },
      });
    });
  }
}

export default Webos;
